import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import type { ReactNode } from "react";
import { Divider } from "@/components/Divider/Divider.component";
type CardHeadingProps = {
  readonly className?: string;
  readonly children: ReactNode;
  readonly variant?: "secondary" | "silver";
};
export function CardHeading(t0) {
  const $ = _c(10);
  const {
    children,
    className,
    variant
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = clsx(className, "wrap-break-word hyphens-manual text-center font-bold text-xl leading-tight");
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <h1 className={t1}>{children}</h1>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== variant) {
    t3 = <Divider className="relative" orientation="horizontal" variant={variant} />;
    $[5] = variant;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <header className="grid gap-2">{t2}{t3}</header>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}